'use client';
import StoreLocator from 'components/commercetools-ui/organisms/storeLocator';
import React from 'react';

function StoreLocatorTastic() {
  return (
    <div>
      <StoreLocator />
    </div>
  );
}

export default StoreLocatorTastic;
